<script lang="ts">
  import type { RichTextBlockComponentProps } from './types';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  export let nodeType: RichTextBlockComponentProps['nodeType'];
  export let content: RichTextBlockComponentProps['content'];
  export let shouldRender: RichTextBlockComponentProps['shouldRender'];
</script>

{#if nodeType === 'document'}
  {#each content as block}
    <DynamicChildrenComponent children={block} />
  {/each}
{:else if shouldRender}
  <svelte:element this={nodeType}>
    {#each content as inline}
      <DynamicChildrenComponent children={inline} />
    {/each}
  </svelte:element>
{/if}
